import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import Select2 from '../../../components/formControls/Select2';
import { getPbxRoutes } from '../../../js/phone/selectors';
import { getOtherPbxVirtualOperatorNumbers } from '../../../js/me/selectors';

const messages = defineMessages({
  virtualOperator: {
    id: 'PbxRoutesSelect.virtualOperator',
    defaultMessage: 'Virtual Operator',
  }
});

const PbxRoutesSelect = ({
  intl: { formatMessage },
  routes,
  selected,
  onSelect,
  error,
  placeholder,
  isClearable,
  isMulti,
  virtualOperatorNumbers,
  disableVirtualOperator,
}) => {

  const routesOptions =
    routes &&
    routes.map((r) => ({
      value: r.route,
      label: `${r.route} ${r.name ? ` - ${r.name}` : ''}${disableVirtualOperator && virtualOperatorNumbers.indexOf(r.route) >= 0 ? ` (${formatMessage(messages.virtualOperator)})` : ''}`,
      disabled: disableVirtualOperator && virtualOperatorNumbers.indexOf(r.route) >= 0
    }));

  const selectedRoutes = 
    (!selected || !routesOptions)
      ? isMulti ?[]:null 
      : isMulti 
        ? routesOptions.filter((r) => selected.indexOf(r.value)>-1) 
        :routesOptions.filter((r) => r.value === selected); 

  return (
    <Select2
      id="pbxRoutes"
      name="pbxRoutes"
      value={selectedRoutes}
      onChange={onSelect}
      options={routesOptions}
      error={error}
      isClearable={isClearable}
      placeholder={placeholder}
      isMulti={isMulti}
    />
  );
};

PbxRoutesSelect.propTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onSelect: PropTypes.func.isRequired,
  error: PropTypes.string,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  disableVirtualOperator: PropTypes.bool,
};

PbxRoutesSelect.defaultProps = {
  selected:[], 
  error: null,
  isClearable: false,
  placeholder: null,
  isMulti:false,
  disableVirtualOperator: false,
};

function mapStateToProps(state) {
  return {
    routes: getPbxRoutes(state) && getPbxRoutes(state).filter((r) => !r.hidden),
    virtualOperatorNumbers: getOtherPbxVirtualOperatorNumbers(state),
  };
}

export default injectIntl(connect(mapStateToProps)(PbxRoutesSelect));
